import type { AcquisitionChannel, SubscriptionStatus } from "@/domains/subscription/subscription.types";

const acquisitionChannel: Record<AcquisitionChannel, string> = {
  DIGITAL_LEAD: "Lead digital",
  FULL_DIGITAL_SUBSCRIPTION: "Full digital",
  DIRECT_ACQUISITION: "Acquisition directe",
  EXTERNAL_VENDOR: "External vendor",
  LANDLORD: "Bailleur",
};

const subscriptionStatus: Record<SubscriptionStatus, string> = {
  RUNNING: "En Cours",
  COMPLETED: "Terminée",
  FAILED: "Échouée",
};

const subscriptionLocale = {
  subscription: {
    create: {
      cta: "Créer une adhésion",
      confirmation: {
        title: "Créer une adhésion",
        message: "Voulez-vous créer une nouvelle adhésion pour ce site ?",
        replaceExistingMessage:
          "Une adhésion est déjà en cours. La nouvelle adhésion clôturera l'adhésion existante et la remplacera. Voulez-vous continuer ?",
        acceptLabel: "Créer l'adhésion",
        rejectLabel: "Annuler",
      },
    },
    emptyState: {
      title: "Aucune adhésion",
      description: "Aucune adhésion n'a encore été créée pour ce site.",
    },
    errorState: {
      title: "Erreur lors du chargement de l'adhésion",
      description: "Merci de réessayer ultérieurement.",
    },
    header: {
      title: "Adhésion #{id}",
      startedOn: "Démarrée le {date}",
      closedOn: "Clôturée le {date}",
      delayedClosureLifted: "clôture différée du {date} levée",
      subscriptionStatus,
    },
    pipelineTimeline: {
      status: {
        initial: "Action requise",
        done: "Terminé",
        failed: "Échec",
        pending: "En attente",
        notRequired: "Non requis",
        inProgress: "En cours",
        finalizationRequired: "Finalisation requise",
      },
      step: {
        prospection: "Prospection",
        confirmation: "Confirmation",
        installation: "Installation",
      },
    },
    activeCard: {
      takeAppointmentCta: "Prendre un rendez-vous",
      actionsMenuCta: "Afficher les autres actions",
      showDetailsCta: "Afficher les détails",
      hideDetailsCta: "Masquer les détails",
      confirmEligibilityCta: "Confirmer l'éligibilité",
      reOpenSubscriptionCta: "Ré-ouvrir l'adhésion",
      viewHistoryCta: "Historique des adhésions",
      failureLabel: "Échec",
      delayedClosure: {
        label: "Clôture programmée",
        scheduledOn: "Prévue le {date}",
      },
      pastFailures: {
        message:
          "Aucune adhésion passée en échec | Une adhésion passée s'est soldée par un échec sur ce site. | {count} adhésions passées se sont soldées par un échec sur ce site.",
        cta: "Voir l'historique",
      },
      prospection: {
        title: "Phase de Prospection",
        partnerLabel: "Porteur",
        acquisitionChannelLabel: "Canal d'acquisition",
        acquisitionChannel,
      },
      eligibility: {
        title: "Confirmation d'Éligibilité",
      },
      tags: {
        title: "Tags",
        empty: "Aucun tag",
        count: "{count} tag(s)",
        addPlaceholder: "Ajouter un tag",
        filterPlaceholder: "Rechercher un tag",
        noAvailableTags: "Aucun tag disponible",
        noSearchResult: "Aucun tag ne correspond",
        availableTagsError: "Tags indisponibles",
        removeCta: "Supprimer le tag",
      },
      installation: {
        title: "Installation",
        awaitingAppointment: "L'adhérent est en attente de la prise de rendez-vous pour l'installation.",
        appointmentCanceled: "Précédente intervention annulée, un rendez-vous est à prévoir pour ce site",
        appointmentCompromised: "Ce rendez-vous est compromis, un nouveau rendez-vous est à prévoir pour ce site",
        dateAndTimeLabel: "Date & heure",
        technicianLabel: "Technicien",
        technicianUnknown: "Inconnu",
        newInterventionRequired: "Un rendez-vous de finalisation est attendu pour ce site",
      },
    },
    history: {
      title: "Historique des adhésions",
      filter: {
        label: "Statut",
        all: "Toutes",
        subscriptionStatus,
      },
      resultCount: "Aucune adhésion | {count} adhésion | {count} adhésions",
      truncationNotice: "Les {shown} adhésions les plus récentes sur {total}.",
      currentBadge: "Adhésion courante",
      startedOn: "Démarrée le {date}",
      closedOn: "Clôturée le {date}",
      noFailure: "Aucun échec enregistré",
      unknownOperator: "Opérateur inconnu",
      details: {
        subscriberLabel: "Adhérent",
        pipelineLabel: "Pipeline",
        reasonCodeLabel: "Code de la cause",
      },
      showDetailsCta: "Afficher les détails",
      hideDetailsCta: "Masquer les détails",
      errorState: {
        title: "Erreur lors du chargement de l'historique",
        description: "Merci de réessayer ultérieurement.",
      },
      emptyState: {
        title: "Aucune adhésion",
        description: "Aucune adhésion ne correspond à ce filtre.",
      },
    },
  },
};

export type SubscriptionLocale = typeof subscriptionLocale;
export default subscriptionLocale;
